import React from 'react';
import { Controller } from 'react-hook-form';
import { MenuItem, TextField, Typography, InputAdornment, IconButton } from '@mui/material';
import { Clear } from '@mui/icons-material';

const FieldSelect = ({ control, name, label, options, disabled, disableClear, disabledOptions, rules, setValue }) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field, fieldState }) => (
        <TextField
          {...field}
          label={label}
          variant="filled"
          select
          fullWidth
          disabled={disabled}
          slotProps={{
            input: {
              endAdornment:
                field.value && !disableClear ? (
                  <InputAdornment
                    position="end"
                    sx={{ mr: 2 }}
                  >
                    <IconButton
                      onClick={() => setValue(field.name, '')}
                      edge="start"
                      size={'small'}
                      disabled={disabled}
                    >
                      <Clear />
                    </IconButton>
                  </InputAdornment>
                ) : null,
            },
          }}
        >
          {options.map((option) => (
            <MenuItem
              key={option.value}
              value={option.value}
              disabled={disabledOptions?.length > 0 ? disabledOptions.some((item) => item === option.value) : false}
            >
              <Typography variant="inherit">{option.name}</Typography>
            </MenuItem>
          ))}
        </TextField>
      )}
    />
  );
};

export default FieldSelect;
